import React, { useState } from "react";
import IMAGES from "../../../constant/IMAGES";
import { toast } from "react-toastify";
import Notify from "../../Notify";

const items = [
  {
    text: "Trang chủ",
    href: "#",
  },
  {
    text: "Về chúng tôi",
    href: "#ve-chung-toi",
  },
  {
    text: "Tính năng nổi bật",
    href: "#tinh-nang-noi-bat",
  },
  {
    text: "Tính năng độc quyền",
    href: "#tinh-nang-doc-quyen",
  },
  { text: "Liên hệ", href: "#lien-he" },
  {
    text: "Hỏi đáp",
    href: "#hoi-dap",
  },
];

const images = [
  {
    img: IMAGES.fb,
    link: "https://www.facebook.com/profile.php?id=61571067405665",
  },
  { img: IMAGES.zalo, link: "https://zalo.me/287747822325857598" },
  {
    img: IMAGES.tiktok,
    link: "https://www.tiktok.com/@phongthuydainamofficial",
  },
  { img: IMAGES.ytb, link: "https://www.youtube.com/@xhero-app" },
];

const SectionFooter = () => {
  const [value, setValue] = useState("");

  return (
    <div className="flex flex-col gap-8 pb-16 xl:pb-36">
      <div
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-offset="10"
        data-aos-once="false"
        className="flex xl:flex-row flex-col xl:items-center justify-between gap-10 md:py-16 md:pl-16 px-[15px] py-5 bg w-full xl:w-[95%] position-relative rounded-[10px]"
      >
        <h2 className="text-white text-xl md:text-[32px]/[38.21px] font-semibold">
          Đăng ký email để nhận thông tin sớm nhất
        </h2>
        <div className="xl:flex hidden relative w-[42%]">
          <div className="gradient-borderFull before:opacity-50 rounded-lg overflow-hidden h-[72px] aspect-[608/72] w-full translate-x-24 z-[1]">
            <img
              src={IMAGES.overlay}
              alt="overlay"
              className={`absolute top-0 left-0 w-full h-[72px] opacity-50 object-cover z-[1] pointer-events-none`}
            />
            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              name="email"
              className="bg-[#000000be] w-full h-[72px] pointer-events-auto contact relative text-base p-6 text-[#FAFAFA] placeholder:text-[#FAFAFA]"
              placeholder="Nhập email của bạn"
            />
          </div>
          <button
            onClick={() => {
              if (value !== "") {
                toast(<Notify />, {
                  closeButton: true,
                  className:
                    "h-[118px] w-[300px] md:w-[524px] items-center bg-[#0E2411] bg-bgNotiSuss bg-no-repeat bg-cover px-3 md:px-8 p-8 rounded-[12px] border-[1px] border-[#30D158] shadow-[0px_8px_8px_-4px_#1018280A]",
                  ariaLabel: "Lưu thông báo thất bại",
                });
                setValue("");
              }
            }}
            className="bg-[#F0D35A] text-black py-3 px-10 text-sm whitespace-nowrap font-semibold h-[48px] absolute z-30 right-3 top-1/2 translate-x-24 -translate-y-1/2 rounded-lg"
          >
            Đăng kí ngay
          </button>
        </div>
        <div className="flex items-center relative w-full xl:hidden">
          <div className="gradient-borderYellow rounded-lg overflow-hidden h-[58px] w-[93%] flex before:z-[1]">
            <img
              src={IMAGES.overlay}
              alt="overlay"
              className={`absolute top-0 left-0 w-full h-[58px] opacity-50 object-cover z-[1] pointer-events-none`}
            />
            <input
              value={value}
              onChange={(e) => setValue(e.target.value)}
              name="email"
              className="bg-[#000000be] w-full h-[58px] z-10 min-w-[300px] pointer-events-auto contact relative text-base p-6 text-[#FAFAFA] placeholder:text-[#FAFAFA]"
              placeholder="Nhập email của bạn"
            />
          </div>
          <button
            onClick={() => {
              if (value !== "") {
                toast(<Notify />, {
                  closeButton: true,
                  className:
                    "h-[118px] w-[300px] md:w-[524px] items-center bg-[#0E2411] bg-bgNotiSuss bg-no-repeat bg-cover px-3 md:px-8 p-8 rounded-[12px] border-[1px] border-[#30D158] shadow-[0px_8px_8px_-4px_#1018280A]",
                  ariaLabel: "Lưu thông báo thất bại",
                });
                setValue("");
              }
            }}
            className="bg-[#F0D35A] text-black px-3 py-2 text-sm whitespace-nowrap font-semibold rounded-lg right-0 absolute z-30"
          >
            Đăng kí ngay
          </button>
        </div>
      </div>

      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="0"
        data-aos-once="false"
        className="flex xl:flex-row flex-col gap-6 justify-between items-start xl:items-center"
      >
        <img src={IMAGES.logoNgang} alt="logo" className="block xl:hidden" />

        <div className="w-2/3 flex xl:flex-row flex-col gap-6 justify-between items-start xl:items-center">
          {items.map((item, index) => {
            return (
              <a
                key={index}
                href={item.href}
                className="text-[#FAFAFA] text-xl no-underline hover:text-goldGradient transition-all duration-300"
              >
                {item.text}
              </a>
            );
          })}
        </div>
        <div className="flex">
          {images.map((item, index) => (
            <a href={item.link} target="_blank" key={index} rel="noreferrer">
              <img
                src={item.img}
                alt={item.img}
                className="transition-transform duration-1000 hover:rotate-[360deg] ease-in-out"
              />
            </a>
          ))}
        </div>
      </div>
      <hr
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-offset="0"
        data-aos-once="false"
        className="border-[0.5] border-[#A89850] w-full"
      />
      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
        data-aos-offset="0"
        data-aos-once="false"
        className="flex xl:flex-row flex-col justify-between xl:items-center gap-5"
      >
        <p className="text-[#FAFAFA] text-base">
          © 2024 Xhero.com. All rights reserved.
        </p>
        <img src={IMAGES.logoNgang} alt="logo" className="xl:block hidden" />
        <div className="flex gap-6 items-center text-base justify-between">
          <a
            href={`https://phongthuydainam.vn/chinh-sach/chinh-sach-chung`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#FAFAFA] hover:text-goldGradient"
          >
            Điều khoản dịch vụ
          </a>
          <a
            href={`https://phongthuydainam.vn/chinh-sach/chinh-sach-bao-mat`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#FAFAFA] hover:text-goldGradient"
          >
            Chính sách bảo mật
          </a>
        </div>
      </div>
    </div>
  );
};

export default SectionFooter;
